import { createSlice } from "@reduxjs/toolkit";
import { fetchAlarmList, updateAlarmStatus } from "../actions/uiActions";

const initialState = {
  loading: false,
  isShowModuleSideBar: true,
  alarms: {
    loading: false,
    error: null,
    data: [],
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setIsShowModuleSideBar: (state, action) => {
      state.isShowModuleSideBar = action.payload;
    },
  },
  extraReducers: {
    [fetchAlarmList.pending]: (state, action) => {
      state.alarms.loading = true;
      state.alarms.error = null;
    },
    [fetchAlarmList.fulfilled]: (state, action) => {
      state.alarms.loading = false;
      state.alarms.error = null;
      state.alarms.data = action.payload;
    },
    [fetchAlarmList.rejected]: (state, action) => {
      state.alarms.loading = false;
      state.alarms.error = action.error.message;
    },

    [updateAlarmStatus.pending]: (state, action) => {},
    [updateAlarmStatus.fulfilled]: (state, action) => {
      const index = state.alarms.data.findIndex(
        (x) => x.id === action.meta.arg
      );
      if (index > -1) {
        state.alarms.data[index].alarmStatus = "Seen";
      }
    },
    [updateAlarmStatus.rejected]: (state, action) => {},
  },
});

const { reducer, actions } = uiSlice;

export const { setLoading, setIsShowModuleSideBar } = actions;
export default reducer;
